import axios from 'axios'

const providerAPI = {
    handleVerifyEmail(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/paypal_email_verification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    // Inbox
    getInbox(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-unread-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    readStatusUpdate(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/read-status-update', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getUnreadNotificationCount(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-unread-notification-count', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    deleteNotification(data){
        return new Promise((resolve, reject) => {
            axios.post('producer/delete-notification', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Booking Settings
    getBookingSettings(data) {
        return new Promise((resolve, reject) => {
            axios.post('provider/edit-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    updateBookingSettings(data) {
        return new Promise((resolve, reject) => {
            axios.post('provider/update-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Orders
    getOrders(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-orders', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getOrderDetails(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-order-details', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // update shipping status
    updateShippingStatus(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/update-shipping-status', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    /*getInvoices*/
    getInvoices(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/invoice-list', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    activeCategory() {
        return new Promise((resolve, reject) => {
            axios.get('active-categories').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    
    /* NEW */
    getActiveBadges() {
        return new Promise((resolve, reject) => {
            axios.get('active-badges').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProductInfo() {
        return new Promise((resolve, reject) => {
            axios.get('active-product-informations').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    //payment options
    getPaymentOptions() {
        return new Promise((resolve, reject) => {
            axios.get('active-payment-options').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
     //get product features
     getProductFeatures() {
        return new Promise((resolve, reject) => {
            axios.get('active-product-features').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    //get product certificates
    getProductCertificates() {
        return new Promise((resolve, reject) => {
            axios.get('active-certifications').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getStates() {
        return new Promise((resolve, reject) => {
            axios.get('active-states').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getProductUnits() {
        return new Promise((resolve, reject) => {
            axios.get('active-units').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getDeliveryOptions() {
        return new Promise((resolve, reject) => {
            axios.get('active-delivery-options').then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    activeProducerCategory(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-producer-categories/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // PRODUCTS APIs    
    getProducts(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-products', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    statusProduct(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/status-product', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    addProductStock(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/add-product-stock', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getWishlist(data) {
        return new Promise((resolve, reject) => {
            axios.post('/customer/get-product-wishlist', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    
    updateGeneralSetting(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/update-general-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getGeneralSettings(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-general-settings', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    getAdminGeneralSettings(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-admin-general-setting', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Documents
    getDocuments(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-active-document', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },

    // Support
    getSupportQuery(data) {
        return new Promise((resolve, reject) => {
            axios.post('producer/get-support-query/' + data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    },
    dashboardNotification(data) {
        return new Promise((resolve, reject) => {
            axios.post('/producer/dashboard', data).then((response) => {
                resolve(response.data)
            }, (error) => {
                reject(error)
            })
        })
    }
    /* END NEW */
}

export default providerAPI
